import api from './api';

export const resumeBuilderApi = api.injectEndpoints({
  endpoints: builder => ({
    /* TEMPLATE APIs */

    fetchResumeTemplates: builder.query({
      query: () => ({
        url: '/resume/template/fetch/all',
        method: 'GET'
      })
    }),

    createResumeTemplate: builder.mutation({
      query: body => ({
        url: '/resume/template/create',
        method: 'POST',
        body
      })
    }),

    createResume: builder.mutation({
      query: body => ({
        url: '/resume/create',
        method: 'POST',
        body
      })
    }),

    updateResume: builder.mutation({
      query: body => ({
        url: '/resume/update',
        method: 'PUT',
        body,
        params: {
          resumeId: body.id
        }
      })
    }),

    fetchResumeById: builder.query({
      query: (resumeId: string) => ({
        url: '/resume/fetch/resume/by/id',
        method: 'GET',

        params: {
          resumeId
        }
      })
    }),

    generateResumeFromForm: builder.mutation({
      query: (userFormId: string) => ({
        url: `/api/resume/generation/from/form?userFormId=${userFormId}`,
        method: 'POST'
      })
    }),

    getDraftResume: builder.query({
      query: () => ({
        url: '/resume/fetch/form/pending/resume',
        method: 'GET'
      })
    }),

    fetchDropdownInfo: builder.query({
      query: () => ({
        url: '/resume/fetch/dropdown/info',
        method: 'GET'
      })
    }),
    uploadResume: builder.mutation({
      query: (formData: FormData) => ({
        url: '/api/resume/scrape/from/pdf',
        method: 'POST',
        body: formData
      })
    }),
    scrapeResumeForATS: builder.mutation({
      query: (formData: FormData) => ({
        url: '/api/resume/ats/from/pdf',
        method: 'POST',
        body: formData
      })
    }),
    analyseATS: builder.mutation({
      query: (body: {
        resumeId: string;
        jobTitle: string;
        jobDescription: string;
      }) => ({
        url: '/api/resume/ats/analyze',
        method: 'POST',
        body
      })
    }),

    fetchResumesByUser: builder.query({
      query: () => ({
        url: '/resume/fetch/by/user',
        method: 'GET'
      })
    })
  })
});

export const {
  useFetchResumeTemplatesQuery,
  useCreateResumeTemplateMutation,
  useCreateResumeMutation,
  useUpdateResumeMutation,
  useFetchResumeByIdQuery,
  useLazyFetchResumeByIdQuery,
  useGetDraftResumeQuery,
  useFetchDropdownInfoQuery,
  useGenerateResumeFromFormMutation,
  useUploadResumeMutation,
  useScrapeResumeForATSMutation,
  useAnalyseATSMutation,
  useFetchResumesByUserQuery,
  useLazyFetchResumesByUserQuery
} = resumeBuilderApi;
